export class PobierzDaneDoSpisuSrodkaModel {
  idProjektu: string;
  idSrodka: string;
  idPomieszczenia: string;
}
